import { render, staticRenderFns } from "./deposits-product-type.vue?vue&type=template&id=586c97b2"
import script from "./deposits-product-type.vue?vue&type=script&lang=js"
export * from "./deposits-product-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports